
/* eslint-disable @typescript-eslint/camelcase */
import { Options, Vue } from "vue-class-component";
import Sidebar from "@/app/ui/components/sidebar/index.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import Loading from "@/app/ui/components/loading/index.vue";
import Banner from "@/app/ui/views/banner/index.vue";
import FloatingBooking from "@/app/ui/components/floating-booking/index.vue";
import MultipleSnackbar from "@/app/ui/components/multiple-snackbar/index.vue";
import AccountAlertContainer from "@/app/ui/components/account-alert/AccountAlertContainer.vue";
import { FirebaseController } from "../controllers/FirebaseController";
import { playNotification } from "@/app/infrastructures/misc/UtilsAudio";
import replaceDoubleBraces from "@/app/infrastructures/misc/common-library/ReplaceDoubleBraches";
import formatDate from "@/app/infrastructures/misc/common-library/FormatDate";
import { CargoController } from "../controllers/CargoController";
import { AccountController } from "../controllers/AccountController";
import { BalanceMinusPenaltyController } from "@/app/ui/controllers/BalanceMinusPenaltyController";
import { BalanceController } from "@/app/ui/controllers/BalanceController";
import { NotificationsAll } from "@/domain/entities/BalanceMinusPenalty";
import router from "../router";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import WatermarkPage from "@/app/ui/layout/watermark-page.vue";
import SidebarV2 from "@/app/ui/layout/sidebar/index.vue";
import { FlagsSidebar } from "@/feature-flags/flags-sidebar";
import { getDataLocalStorage } from "@/app/infrastructures/misc/LocalStorage";
import { IS_SENDER_ACCOUNT } from "@/app/infrastructures/misc/Constants";
import {
  formatDateNumber,
  getWatermark
} from "@/app/infrastructures/misc/Utils";
import { ActivityController } from "../controllers/ActivityController";
import { SendActivityApiRequest } from "@/data/payload/api/ActivityApiRequest";
import ToastLoginApproval from "./components/toast-login-approval.vue";
import ToastSuccessV2 from "./components/toast-success-v2.vue";
import { Snackbar } from "@/domain/entities/MainApp";
import { NotificationController } from "../controllers/NotificationController";
import { ManagementLoginApprovalController } from "../controllers/ManagementLoginApprovalController";
import { LoginApprovalRequest } from "@/domain/entities/ManagementLoginApproval";
import { AuthController } from "../controllers/AuthController";
import ToastSuccessAnnouncement from "./components/toast-success-announcement.vue";

@Options({
  components: {
    WatermarkPage,
    Loading,
    sidebar: Sidebar,
    Banner,
    FloatingBooking,
    MultipleSnackbar,
    AccountAlertContainer,
    SidebarV2,
    ToastLoginApproval,
    ToastSuccessV2,
    ToastSuccessAnnouncement
  },
  computed: {
    getCurrentRoute() {
      return this.$route;
    }
  }
})
export default class Layout extends Vue {
  rerenderWatermark = 0;
  watermarkInterval: any = null;
  watermarkOuterHtml = "";

  created() {
    // handle scanner press CTRL+Shift+J
    document.addEventListener.call(
      window,
      "keydown",
      (event: any) =>
        event.ctrlKey &&
        event.shiftKey &&
        event.keyCode == 74 && // J
        event.preventDefault()
    );
  }
  mounted() {
    this.checkSidebarV2();

    // toast realtime notification
    FirebaseController.onMessageFirebase((payload: any) => {
      console.log(
        "🚀 ~ Layout ~ FirebaseController.onMessageFirebase ~ payload:",
        payload
      );

      if (payload.data?.is_master_device === "true") {
        this.onShowToastLoginApproval(payload.data?.username);
      }

      const severityMap: Record<string, string> = {
        success: "success",
        error: "error",
        failed: "error"
      };

      const { status } = payload.data;
      const isConsole =
        AccountController.accountData.isConsoleAccount ||
        AccountController.accountData.isSubConsoleAccount;

      this.detailMultipleSnackBar.severityNotif = status.toLowerCase();
      this.detailMultipleSnackBar.isFcmNotif = true;
      console.log(
        "🚀 ~ Layout ~ FirebaseController.onMessageFirebase ~ this.detailMultipleSnackBar.severityNotif:",
        this.detailMultipleSnackBar.severityNotif
      );

      if (isConsole) {
        console.log(
          "🚀 ~ Layout ~ FirebaseController.onMessageFirebase ~ cargo:"
        );
        playNotification(
          status.toLowerCase() === "failed" ? "failed_cargo" : "success_cargo"
        );
        CargoController.updateLastReadCargo();

        this.$toast.add({
          severity: severityMap[status.toLowerCase()],
          detail: `${this.messageFirebaseNotification(payload)}`,
          life: 10000
        });
      } else if (payload.data?.is_kulioner) {
        console.log(
          "🚀 ~ Layout ~ FirebaseController.onMessageFirebase ~ payload.data?.data?.is_kulioner:",
          payload.data?.is_kulioner
        );
        this.$toast.add({
          severity: "success",
          summary: payload.data.notification_title,
          detail: `<div class="text-green-lp-400 truncate overflow-hidden" style="max-width: 345px;">${payload.data.notification_body}</div> <a href="/kulioner?tab=ORDWTC" class="font-bold cursor-pointer text-green-lp-400">Cek Pesanan!</a>`,
          life: 10000,
          closable: true,
          iconClosePosition: "start"
        });
      } else {
        this.$toast.add({
          severity: severityMap[status.toLowerCase()] || "warning",
          detail:
            payload.data?.notification_title || payload.notification.title,
          life: 10000,
          closable: false,
          id: payload.data.id,
          editable: true
        });
      }
    });
    this.getBalanceMinus();
    this.defineMultipleSnackBar();
    this.checkRunningText();
    this.showAccountAlerts();

    // handle watermark changes activity;
    this.watermarkOuterHtml =
      document.getElementsByClassName("watermark")?.[0]?.outerHTML || "";
    this.watermarkInterval = setInterval(() => {
      const watermark = document.getElementsByClassName(
        "watermark"
      )?.[0] as HTMLElement;
      if (!watermark) return this.handleRerenderWatermark();
      const encrypted = getWatermark().backgroundImage;
      if (!encrypted) return;
      const after = watermark.outerHTML;
      const isModified = after !== this.watermarkOuterHtml;
      const isChanged = watermark.style.backgroundImage !== encrypted;
      if (isChanged || isModified) this.handleRerenderWatermark(after);
    }, 250);
  }

  unmounted() {
    if (this.watermarkInterval) clearInterval(this.watermarkInterval);
  }

  get showMfaEnrollmentAlert() {
    return (
      AccountController.accountData.isLogin2FaEnable &&
      !AccountController.accountData.isLogin2FaEnrolled
    );
  }

  get shouldChangePasswordAt() {
    return AccountController.accountData.shouldChangePasswordAt;
  }

  autoRequestOtpAndRedirect() {
    return AuthController.autoRequestOtpAndRedirect();
  }

  get shouldShowChangePassword(): boolean {
    const dateValue = this.shouldChangePasswordAt;
    if (!dateValue) return false;

    const targetDate = new Date(dateValue);
    if (isNaN(targetDate.getTime())) return false;

    const minus7Days = new Date(targetDate);
    minus7Days.setDate(minus7Days.getDate() - 7);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    minus7Days.setHours(0, 0, 0, 0);

    return today >= minus7Days;
  }

  get diffDaysChangePassword(): number | null {
    if (!this.shouldChangePasswordAt) return null;

    const target = new Date(this.shouldChangePasswordAt);
    if (isNaN(target.getTime())) return null;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);

    const diffMs = target.getTime() - today.getTime();
    return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  }

  get diffDayValueChangePassword() {
    return this.diffDaysChangePassword === 0
      ? "hari ini"
      : `${this.diffDaysChangePassword} hari`;
  }

  get passwordExpiredTitle() {
    if (!this.shouldShowChangePassword || this.diffDaysChangePassword === null) {
      return this.$t("authenticator.alertChangePassword.title");
    }

    if (this.diffDaysChangePassword !== 0) {
      return this.$t("authenticator.alertChangePassword.titleWithDiff", {
        day: Math.abs(this.diffDaysChangePassword)
      });
    } else {
      return this.$t("authenticator.alertChangePassword.titleToday");
    }
  }

  isAccountAlertDismissed(id: string | number) {
    return !!AuthController.dismissedAccountAlerts[String(id)];
  }

  dismissAccountAlert(id: string | number) {
    AuthController.setAccountAlertDismissed(String(id));
    MainAppController.removeAccountAlert(id);
  }

  showAccountAlerts() {
    if (
      this.showMfaEnrollmentAlert &&
      !this.isAccountAlertDismissed("otp-alert") &&
      AccountController.accountData.isEligibleSetupOtp
    ) {
      MainAppController.addAccountAlert({
        id: "otp-alert",
        title: this.$t("authenticator.alert.title"),
        message: this.$t("authenticator.alert.message"),
        actionLabel: this.$t("authenticator.alert.buttonText"),
        icon: "lp-icon-info",
        onAction: () => {
          this.dismissAccountAlert("otp-alert");
          this.autoRequestOtpAndRedirect();
        }
      });
    }

    if (
      this.shouldShowChangePassword &&
      !this.isAccountAlertDismissed("password-alert")
    ) {
      MainAppController.addAccountAlert({
        id: "password-alert",
        title: this.passwordExpiredTitle,
        message: this.$t("authenticator.alertChangePassword.message"),
        actionLabel: this.$t("authenticator.alertChangePassword.buttonText"),
        icon: "lp-icon-info",
        onAction: () => {
          this.dismissAccountAlert("password-alert");
          this.$router.push("/account?type=change-password");
        }
      });
    }
  }

  messageFirebaseNotification(payload: any) {
    const successBooking = `${payload.data.destination_city_code} - ${payload.data.destination_city_name}`;
    const failedBooking = payload.data.reason_failed;
    const isRTCNotif = payload.data.title === "RTC Notification";
    const notifRTC = payload.notification?.body.split(",");
    const cancelBooking = payload.data.message.includes("cancel booking");
    const cargoNo = payload.data.cargo_no;

    if (isRTCNotif) {
      return `<b>${notifRTC[0]}</b> ${notifRTC[1]}`;
    } else if (cancelBooking) {
      return payload.data.status === "success"
        ? this.$t("layout.firebaseNotification.cancel.success", { cargoNo })
        : this.$t("layout.firebaseNotification.cancel.failed", {
            cargoNo,
            reason: failedBooking
          });
    } else {
      return payload.data.status === "success"
        ? this.$t("layout.firebaseNotification.booking.success", {
            cargoNo,
            destination: successBooking
          })
        : this.$t("layout.firebaseNotification.booking.failed", {
            cargoNo,
            reason: failedBooking
          });
    }
  }
  textArray: string[] = [];
  // error modal
  get responseModal() {
    return MainAppController.responseModal;
  }
  get errorModal() {
    return MainAppController.errorMessageModal;
  }
  get errorEntities() {
    return MainAppController.errorMessageEntities;
  }
  get errorTextCancel() {
    return this.errorEntities.onTryAgain ? this.$t("modalButtonBackTitle") : "";
  }
  get errorTextSuccess() {
    return this.errorEntities.onTryAgain
      ? this.$t("modalButtonTryAgainTitle")
      : this.errorEntities.buttonSuccessText;
  }
  get errorOnSubmit() {
    return this.errorEntities.onTryAgain
      ? this.errorEntities.onTryAgain
      : this.closeErrorModal;
  }
  get isShowRunningText() {
    return !!FlagsMedusa.information_running_text.getValue().replace(" | ", "");
  }
  closeErrorModal() {
    this.errorEntities?.onClose?.();
    MainAppController.closeErrorMessage();
  }
  setCloseResponseModal() {
    MainAppController.closeResponseModal();
  }
  setConfirmResponseModal() {
    this.setCloseResponseModal();
    this.errorEntities?.onClose?.();
  }

  // modal message
  get messageModal() {
    return MainAppController.messageModal;
  }
  get messageEntities() {
    return MainAppController.messageEntities;
  }

  // loading
  get loadingModal() {
    return MainAppController.loadingModal;
  }
  set loadingModal(bool: boolean) {
    MainAppController.setLoadingModal(bool);
  }
  get loadingMessage() {
    return MainAppController.loadingMessage;
  }

  // snackbar
  get snackbarRerender() {
    return MainAppController.snackbarRerenderKey;
  }
  get snackbar() {
    return MainAppController.snackbar;
  }
  get snackbarMessage() {
    return MainAppController.snackbarMessage;
  }
  get snackbarPositive() {
    return MainAppController.snackbarPositive;
  }
  get snackbarTimeout() {
    return MainAppController.snackbarTimeout;
  }
  get snackbarAutoClose() {
    return MainAppController.snackbarAutoClose;
  }
  get snackbarBackgroundColor() {
    return MainAppController.snackbarBackgroundColor;
  }
  get snackBarIconLeft() {
    return MainAppController.snackbarIconLeft;
  }
  get snackbarData() {
    return MainAppController.snackbarData;
  }

  get accountAlerts() {
    return MainAppController.accountAlerts;
  }

  onCloseAccountAlert(id: string | number) {
    this.dismissAccountAlert(id);
  }

  toggleSnackbar(bool: boolean) {
    MainAppController.setSnackbar(bool);

    if (!bool) {
      MainAppController.setSnackbarData();
    }
  }

  openCollapseSidebar() {
    AccountController.setIsCollapseSidebar(
      !AccountController.isCollapseSidebar
    );
  }
  toDashboard() {
    router.push("/");
  }

  async getBalanceMinus() {
    if (
      AccountController.accountData.isPosAccount &&
      AccountController.accountData.account_type_detail.isCodDelivery
    ) {
      const res = await BalanceMinusPenaltyController.getAllNotifications();
      if (this.isShowBalanceNotification) {
        res.forEach((item: NotificationsAll) => {
          const status = item.status === "info" ? "warning" : "error";
          const message = item.message;
          const dueDate: any = {
            np_due_date: formatDate(item.dueDate)
          };

          const newMessage = replaceDoubleBraces(message, dueDate);
          this.$toast.add({
            severity: status,
            detail: newMessage
          });
        });
      }
    }
  }

  detailMultipleSnackBar = {
    title: "",
    isClickable: false,
    isEditable: false,
    severityNotif: "",
    isFcmNotif: false
  };

  onShowToastLoginApproval(username: string) {
    NotificationController._getNotificationSidebarData({
      page: 1,
      limit: 10,
      status: "",
      search: "",
      isPinned: 0,
      sort: "",
      cache: true
    });

    const today = new Date();
    const start = new Date();
    start.setDate(today.getDate() - 14);

    ManagementLoginApprovalController.getLoginRequests(
      new LoginApprovalRequest({
        startDate: formatDateNumber(start),
        endDate: formatDateNumber(today)
      })
    );

    MainAppController.setSnackbarData(
      new Snackbar({
        type: "login-approval",
        title: "Permintaan login",
        message: `Permintaan login <span class="font-bold">${username}</span>`,
        onAction: () => {
          this.$router.push("/management-login-approval");
        }
      })
    );
    MainAppController.setAutoClose(true);
    MainAppController.setSnackbar(true);
  }

  defineMultipleSnackBar() {
    const account =
      AccountController.accountData.account_type_detail.type ||
      AccountController.accountData.account_type;

    const isSuccess = this.detailMultipleSnackBar.severityNotif === "success";

    const detailAccount: Record<
      string,
      { title: string; isClickable: boolean; isEditable: boolean }
    > = {
      console: {
        title: this.detailMultipleSnackBar.isFcmNotif ? "Notifikasi Kargo" : "",
        isClickable: false,
        isEditable: false
      },
      pos: {
        title: "",
        isClickable: false,
        isEditable: !isSuccess
      },
      internal: {
        title: "",
        isClickable: false,
        isEditable: !isSuccess
      },
      client: {
        title: "",
        isClickable: false,
        isEditable: !isSuccess
      }
    };

    const selectedAccount = detailAccount[account] ?? {
      title: "",
      isClickable: false,
      isEditable: false
    };

    Object.assign(this.detailMultipleSnackBar, selectedAccount);
  }

  get isShowBalanceNotification() {
    return (
      AccountController.accountData.isPosAccount &&
      BalanceController.balanceData.walletBalance <= 0
    );
  }

  get isShowCargoNotification() {
    return (
      AccountController.accountData.isConsoleAccount ||
      AccountController.accountData.isSubConsoleAccount
    );
  }

  get isShowBulkBookingNotif() {
    return (
      AccountController.accountData.isPosAccount ||
      AccountController.accountData.isInternalAccount ||
      AccountController.accountData.isAllClient
    );
  }

  get isAccountForeign() {
    return AccountController.accountData.accountIsForeign;
  }

  get newLayoutDesign() {
    const routeNames = [
      "bulk-v2",
      "kulioner-detail",
      "kulioner-list",
      "dispatch",
      "pusat-resolusi-v2-list",
      "pusat-resolusi-v2-detail",
      "ticket_escalate",
      "my_ticket",
      "ticket_followed",
      "shipment-booking-v3-create",
      "shipment-booking-v3-edit",
      "shipment-booking-v3-create-client",
      "shipment-booking-v2-create",
      "shipment-booking-v2-edit",
      "shipment-booking-v2-create-client",
      "booking-v2-list",
      "booking-v2-client-cbp-list",
      "shipment-booking-v2-duplicate-retail",
      "shipment-booking-v2-duplicate-client",
      "shipment-booking-v3-create-client",
      "edit-on-process-stt-v3",
      "booking-v3-create-client",
      "hub-to-hub-in-hub",
      "hub-to-hub-out-hub",
      "update-in-hub",
      "update-out-hub",
      "operational-area",
      "hanging-incoming",
      "hanging-lastmile",
      "cari-stt-scan",
      "cari-stt",
      "cari-stt-list",
      "history-follow-up-incoming",
      "history-follow-up-lastmile",
      "history-hanging-incoming",
      "history-hanging-lastmile",
      "daily-deposit"
    ];

    return (
      this.$route.meta?.newLayout ||
      routeNames.includes(this.$route.name as string)
    );
  }

  get noPaddingWithBreadcrumbV2(): boolean {
    return !!this.$route.meta?.noPaddingWithBreadcrumbV2;
  }

  get layoutNoPadding(): boolean {
    return !!this.$route.meta?.layoutNoPadding;
  }
  checkRunningText() {
    const minimumText = 6;
    if (!this.isShowRunningText) return;
    let textArray = FlagsMedusa.information_running_text
      .getValue()
      .split(" | ")
      .filter((text) => text) as string[];
    const isDoubleArray = textArray.length === 4 || textArray.length === 5;
    if (isDoubleArray) {
      textArray = textArray.concat(textArray);
    }
    if (textArray.length < minimumText) {
      const remainingText = minimumText - textArray.length;
      const textArrayLength = textArray.length;
      let count = 0;
      for (let i = 0; i < remainingText; i++) {
        if (count === textArrayLength) count = 0;
        textArray.push(textArray[count]);
        count++;
      }
    }
    setTimeout(() => {
      this.textArray = textArray;
    }, 1000);
  }

  get totalTimeRunningText() {
    return `${this.textArray.reduce((sum, str) => sum + str.length, 0) / 6}s`;
  }

  // sidebar v2
  get permissionToggleVersionSidebarEnabled() {
    return FlagsSidebar.permission_toggle_version_sidebar_enabled.isEnabled();
  }
  get permissionSidebarV2Enabled() {
    return FlagsSidebar.permission_sidebar_v2_enabled.isEnabled();
  }
  get isSidebarAndBreadcrumbV2() {
    return (
      MainAppController.isSidebarAndBreadcrumbV2 &&
      this.permissionSidebarV2Enabled &&
      !IS_SENDER_ACCOUNT
    );
  }
  checkSidebarV2() {
    const value = getDataLocalStorage("is-sidebar-and-breadcrumb-v2");
    MainAppController.setSidebarAndBreadcrumbV2(
      value !== null ? JSON.parse(value) : true
    );
  }

  handleRerenderWatermark(after = "") {
    const before = this.watermarkOuterHtml;
    ActivityController.sendActivity(
      new SendActivityApiRequest({
        after,
        before,
        activityHeader: "changing-watermark"
      })
    );
    this.rerenderWatermark++;
  }

  get isMobile() {
    return MainAppController.screenSize.width <= 425;
  }
}
